import intl from 'react-intl-universal';

import { DateType } from '@/utils/date';
import { parseYuan2Currency } from '@/utils/number';
import { OccType } from '@/config/constant';
import { DATE_FORMAT, DATE_TIME_FORMAT } from '@/config/reg';

// 日租房预离时间
export const formatDayOutTime: (time: DateType | undefined) => string = (time) => {
  return time ? time.format(DATE_FORMAT) : null;
};

// 钟点房预离时间
export const formatHourOutTime: (time: DateType | undefined) => string = (time) => {
  return time ? time.format(DATE_TIME_FORMAT) : null;
};

// 入住时间
export const getOccSummaryText = (data: {
  count: number;
  type: OccType;
  duration: any;
  amount: string;
}) => {
  if (data.type === OccType.DayUse) {
    return intl.get('reservation_room_day_summary_detail', {
      count: data.count,
      duration: data.duration,
      amount: parseYuan2Currency(data.amount),
    });
  }
  if (data.type === OccType.TimeRENT) {
    return intl.get('reservation_room_hour_summary_detail', {
      count: data.count,
      amount: parseYuan2Currency(data.amount),
    });
  }
  return '';
};
